import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { TeamGroups } from '../models/teamGroups.model';
import { UrlBuilder } from "../models/utils/url-builder.model";

@Injectable()
export class TeamGroupsService {
    constructor(private httpClient: HttpClient) {}

    private endPointMaster: String = "/team-groups";

    async getAllTeamGroups() {
        let teamGroups = await this.httpClient.get(this.endPointMaster);
        return teamGroups;
    }

    async create(consultantGroups: TeamGroups) {
        return await this.httpClient.post(this.endPointMaster, consultantGroups);
    }

    async update(consultantGroups: TeamGroups): Promise<TeamGroups> {
        return await this.httpClient.update(`${this.endPointMaster}`, consultantGroups._id, consultantGroups );
    }

    async getById(id): Promise<TeamGroups>{
        var teamGroupsToEdit = new TeamGroups();
        var response = await this.httpClient.get(`${this.endPointMaster}/${id}`);
        teamGroupsToEdit.loadUserDataForGrid(response);
        return teamGroupsToEdit;
    }

    async getSearchTeamGroups(search) {
        const builder = new UrlBuilder([
            { key: "skip", value: search.skip },
            { key: "limit", value: search.limit }
        ]);
        
        var keyValueParams = [];

        for (let TeamGroupsId of search.TeamGroups)
            keyValueParams.push({ key: "groupId", value: TeamGroupsId });

        for (let consultantsId of search.consultants)
            keyValueParams.push({ key: "consultantId", value: consultantsId });
            
        for (let projectsId of search.projects)
            keyValueParams.push({ key: "projectId", value: projectsId });

        builder.addQueryStringParamsInsideFilter(keyValueParams);

        let teamGroups = await this.httpClient.get(builder.buildUrl(`${this.endPointMaster}/search`));
  
        return teamGroups;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/teamGroups.service.ts